import { george, observer, pr, React, ui } from "aaa";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";
import { GdsFakeActionButtonContainer } from "components/common/GdsFakeActionButtonContainer";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { removeWhitespace } from "util/helpers";
import { TeamcardLinkageStore } from "./TeamcardLinkageStore";
import { TeamcardLinkageRoutes } from "./TeamcardLinkageRoutes";

interface IProps {
    store: TeamcardLinkageStore;
}

export const TeamCardLinkageSMSVerfication = observer(({ store }: IProps) => {
    const [resendCode, setResendCode] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [code, setCode] = React.useState("");
    const [errorMessage, setErrorMessage] = React.useState("");

    const handleResendCode = async () => {
        try {
            setResendCode(true);
            setErrorMessage("");
            await store.requestSMSCode();
        } catch (error) {
            pushRoute("/error");
        } finally {
            setResendCode(false);
        }
    };

    const handleFocus = () => {
        const inputElement = document.getElementById('sms-verification-code');
        if (inputElement) {
            inputElement.focus();
        }
    };

    const handleSendCode = async () => {
        try {
            setLoading(true);
            await store.verifySMSCode(code);
            pushRoute(TeamcardLinkageRoutes.ROOT);
        } catch (error) {
            const errorCode = error.response?.errors?.[0]?.error;
            if (errorCode === "INVALID_FIELD_VALUE") {
                setErrorMessage(ui.__("ichApp.error.invalidCode"));
            } else if (errorCode === "USER_LOCKED") {
                setErrorMessage(ui.__("ichApp.error.userLocked"));
            } else if (errorCode === "LIMIT_REACHED" || errorCode === "GENERIC_ERROR") {
                pushRoute(TeamcardLinkageRoutes.MATCH_ERROR);
            } else if (errorCode === "OTP_VALIDATION_FAILED") {
                setErrorMessage(ui.__("ichApp.error.invalidCode"));
                setCode("");
                handleFocus();

            }
        } finally {
            setLoading(false);
        }
    };

    return (

        <george.Card
            elevated={false}
            style={{ borderRadius: 8 }}
        >
            <div style={{ lineHeight: "24px" }}>
                <div style={{ textAlign: "center", padding: "32px 16px 0 16px" }}>
                    <pr.IconMailXL style={{ color: "#135EE2", width: 48, height: 48, marginBottom: 16 }} />
                    <pr.P_22_TITLE style={{ fontWeight: 700, lineHeight: "28px", textAlign: "center", marginTop: 16 }}>
                        {ui.__("teamCardLinkage.smsOtp.title")}
                    </pr.P_22_TITLE>
                    <george.TextField
                        style={{ marginTop: 32, textAlign: "left" }}
                        label={ui.__("teamcardLinkage.smsOtp.input.label")}
                        id="sms-verification-code"
                        hintText="_ _ _ _"
                        onChange={(e) => {
                            const cleaned = removeWhitespace(e.target.value);
                            const value = Number(cleaned);
                            if (Number.isInteger(value) && value >= 0 && value <= 9999 && cleaned.length <= 4) {
                                setCode(cleaned);
                                setErrorMessage("");
                            }
                        }}
                        inputStyle={{ fontSize: 24, fontVariantNumeric: "tabular-nums" }}
                        value={code}
                        errorMessage={errorMessage}
                    />
                    <pr.P_14_CONTENT style={{ textAlign: "start", fontWeight: 500, lineHeight: "28px", marginTop: 16 }}>
                        {ui.__("teamCardLinkage.smsOtp.info")}
                    </pr.P_14_CONTENT>

                </div>
                <div style={{ padding: 16, marginBottom: 8 }}>
                    <pr.P_14_CONTENT style={{ textAlign: "start", fontWeight: 500, lineHeight: "28px", marginTop: 16 }}>
                        {ui.__("teamCardLinkage.smsOtp.codeNotReceived")}
                    </pr.P_14_CONTENT>
                    <GdsFakeActionButton style={{ marginTop: 8, padding: "0px 8px", display: "inline-block" }} disabled={resendCode} onClick={handleResendCode}>
                        {ui.__("teamCardLinkage.smsOtp.button.resend")}
                    </GdsFakeActionButton>
                </div>
                <pr.LightSeparatorLine />
                <GdsFakeActionButtonContainer>
                    <GdsFakeActionButton
                        color="primary"
                        onClick={handleSendCode}
                        disabled={loading}
                        isLoading={loading}
                        fullWidth={externalInterfaceStore.isGeorgeApp}
                    >
                        {ui.__("teamCardLinkage.smsOtp.button.send")}
                    </GdsFakeActionButton>
                </GdsFakeActionButtonContainer>
            </div>
        </george.Card >
    );

});



// WEBPACK FOOTER //
// ./src/components/teamcardLinkage/TeamCardLinkageSMSVerfication.tsx